import { Tooltip } from '@mui/material';
import type { GatewayType, SensorType } from '@si/types';

import { useColors } from '../ThemeProvider';
import {
  Bracket,
  Gateway,
  GatewayPro,
  Sensor,
  SensorPlus,
  SensorPro,
  SensorWood,
  VentCap,
} from './svg';

interface Props {
  variant?: SensorType | GatewayType | 'ventCap';
  status?: 'ok' | 'error' | 'warning' | 'inactive' | 'highlighted';
  size?: number;
  tooltip?: string;
  color?: string;
}

export function SensorIcon({ variant, status = 'inactive', size = 1, tooltip, color }: Props) {
  const { successLight, errorLight, warningLight, greyLight, secondary } = useColors();

  const statusColor = {
    ok: successLight,
    error: errorLight,
    warning: warningLight,
    inactive: greyLight,
    highlighted: secondary,
  }[status];
  const iconColor = color ?? statusColor;

  const icon = (() => {
    switch (variant) {
      case 'bracket':
        return <Bracket color={iconColor} size={size} />;
      case 'sensor':
        return <Sensor color={iconColor} size={size} />;
      case 'gateway':
        return <Gateway color={iconColor} size={size} />;
      case 'gatewayPro':
        return <GatewayPro color={iconColor} size={size} />;
      case 'sensorPro':
        return <SensorPro color={iconColor} size={size} />;
      case 'sensorPlus':
        return <SensorPlus color={iconColor} size={size} />;
      case 'wood':
        return <SensorWood color={iconColor} size={size} />;
      case 'ventCap':
        return <VentCap color={iconColor} size={size} />;
      default:
        return <SensorPro color={iconColor} size={size} />;
    }
  })();

  if (!tooltip) {
    return icon;
  }

  return (
    <Tooltip title={tooltip}>
      <span style={{ display: 'inline-flex' }}>{icon}</span>
    </Tooltip>
  );
}
